module.exports = __webpack_public_path__ + "static/media/admin orangered.9b25a42a.svg";